/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Image } from './Image';
import {
    ImageFromJSON,
    ImageFromJSONTyped,
    ImageToJSON,
} from './Image';
import type { Price } from './Price';
import {
    PriceFromJSON,
    PriceFromJSONTyped,
    PriceToJSON,
} from './Price';
import type { PromotionRestriction } from './PromotionRestriction';
import {
    PromotionRestrictionFromJSON,
    PromotionRestrictionFromJSONTyped,
    PromotionRestrictionToJSON,
} from './PromotionRestriction';

/**
 * Representation of a Promotion
 * @export
 * @interface Promotion
 */
export interface Promotion {
    /**
     * Code of the promotion
     * @type {string}
     * @memberof Promotion
     */
    code?: string;
    /**
     * Promotion title
     * @type {string}
     * @memberof Promotion
     */
    title?: string;
    /**
     * Type of the promotion
     * @type {string}
     * @memberof Promotion
     */
    promotionType?: string;
    /**
     * The initial date of the promotion
     * @type {Date}
     * @memberof Promotion
     */
    startDate?: Date;
    /**
     * Last date of validity of the promotion
     * @type {Date}
     * @memberof Promotion
     */
    endDate?: Date;
    /**
     * Description of the promotion
     * @type {string}
     * @memberof Promotion
     */
    description?: string;
    /**
     * Message about promotion which is displayed when planning potential promotion. This field has higher priority over promotion description
     * @type {Array<string>}
     * @memberof Promotion
     */
    couldFireMessages?: Array<string>;
    /**
     * Message fired while the promotion is active. This is info how much you will get when applying the promotion
     * @type {Array<string>}
     * @memberof Promotion
     */
    firedMessages?: Array<string>;
    /**
     * 
     * @type {Image}
     * @memberof Promotion
     */
    productBanner?: Image;
    /**
     * Boolean flag if promotion is enabled
     * @type {boolean}
     * @memberof Promotion
     */
    enabled?: boolean;
    /**
     * Priority index as numeric value of the promotion. Higher number means higher priority
     * @type {number}
     * @memberof Promotion
     */
    priority?: number;
    /**
     * Group of the promotion
     * @type {string}
     * @memberof Promotion
     */
    promotionGroup?: string;
    /**
     * List of promotion restrictions
     * @type {Array<PromotionRestriction>}
     * @memberof Promotion
     */
    restrictions?: Array<PromotionRestriction>;
    /**
     * 
     * @type {Array<Price>}
     * @memberof Promotion
     */
    discounts?: Array<Price>;
}

/**
 * Check if a given object implements the Promotion interface.
 */
export function instanceOfPromotion(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PromotionFromJSON(json: any): Promotion {
    return PromotionFromJSONTyped(json, false);
}

export function PromotionFromJSONTyped(json: any, ignoreDiscriminator: boolean): Promotion {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': !exists(json, 'code') ? undefined : json['code'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'promotionType': !exists(json, 'promotionType') ? undefined : json['promotionType'],
        'startDate': !exists(json, 'startDate') ? undefined : (new Date(json['startDate'])),
        'endDate': !exists(json, 'endDate') ? undefined : (new Date(json['endDate'])),
        'description': !exists(json, 'description') ? undefined : json['description'],
        'couldFireMessages': !exists(json, 'couldFireMessages') ? undefined : json['couldFireMessages'],
        'firedMessages': !exists(json, 'firedMessages') ? undefined : json['firedMessages'],
        'productBanner': !exists(json, 'productBanner') ? undefined : ImageFromJSON(json['productBanner']),
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
        'priority': !exists(json, 'priority') ? undefined : json['priority'],
        'promotionGroup': !exists(json, 'promotionGroup') ? undefined : json['promotionGroup'],
        'restrictions': !exists(json, 'restrictions') ? undefined : ((json['restrictions'] as Array<any>).map(PromotionRestrictionFromJSON)),
        'discounts': !exists(json, 'discounts') ? undefined : ((json['discounts'] as Array<any>).map(PriceFromJSON)),
    };
}

export function PromotionToJSON(value?: Promotion | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': value.code,
        'title': value.title,
        'promotionType': value.promotionType,
        'startDate': value.startDate === undefined ? undefined : (value.startDate.toISOString()),
        'endDate': value.endDate === undefined ? undefined : (value.endDate.toISOString()),
        'description': value.description,
        'couldFireMessages': value.couldFireMessages,
        'firedMessages': value.firedMessages,
        'productBanner': ImageToJSON(value.productBanner),
        'enabled': value.enabled,
        'priority': value.priority,
        'promotionGroup': value.promotionGroup,
        'restrictions': value.restrictions === undefined ? undefined : ((value.restrictions as Array<any>).map(PromotionRestrictionToJSON)),
        'discounts': value.discounts === undefined ? undefined : ((value.discounts as Array<any>).map(PriceToJSON)),
    };
}

